import { Stack, Typography } from "@mui/material";

import ZigzagIcon from "../../Home/icons/Zigzag";
import { type Insight } from "../types";

type CloudFlowLabelProps = {
  insight: Insight;
};

const CloudFlowLabel: React.FC<CloudFlowLabelProps> = ({ insight }) => {
  if (!insight.cloudFlowBlueprintId) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2 }}>
      <ZigzagIcon />
      <Typography variant="caption" color="text.secondary">
        Automate with CloudFlow
      </Typography>
    </Stack>
  );
};

export default CloudFlowLabel;
